module.exports = __webpack_public_path__ + "img/largeScreenMapPieBorder.86a30b68.png";